export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<wfs-blog-posts
      :filters='${JSON.stringify(this.content.filter)}'
      grid='${this.content.postsGrid}'
    >
      <template v-slot:post="{post}">
        <div class="wf-overflow-hidden ${this.classes.classes}">
          ${this.buildBlogPostsImageBlock()}
          <div class="wf-blog-posts-content ${this.classes.contentClasses}">
            ${this.buildPostBlocks()}
          </div>
        </div>
      </template>
    </wfs-blog-posts>`
  }

  buildPostBlocks() {
    return this.content.blocks.map(block => this[`build${block}`]()).join('')
  }

  buildBlogPostsImageBlock() {
    if(! this.content.showImage) {
      return ''
    }
    return `<div
      class="wf-h-48 wf-full wf-bg-center wf-bg-cover"
      style="background-image: url('https://images.unsplash.com/photo-1593058097945-4c6c8d09a6b1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2551&q=80')"
    ></div>`
  }


  buildBlogPostsCategories() {
    if(! this.content.showCategories) {
      return ''
    }
    return `<div>
      <span
        v-for="category in post.categories"
        :key="category.id"
        v-text="category.name"
        class="wf-inline-block wf-blog-posts-categories ${this.classes.categoriesClasses}"
      ></span>
    </div>`
  }

  buildBlogPostsTitle() {
    return `<h2 class="wf-blog-posts-title ${this.classes.titleClasses}" v-text="post.title"></h2>`
  }

  buildBlogPostsDescription() {
    if(! this.content.showDescription) {
      return ''
    }
    return `<p class="wf-blog-posts-description ${this.classes.descriptionClasses}" v-text="post.summary"></p>`
  }

  buildBlogPostsAuthor() {
    if(! this.content.showAuthor) {
      return ''
    }
    return `<h4 class="wf-blog-posts-author ${this.classes.authorClasses}" v-text="post.user.name"></h4>`
  }

  buildBlogPostsDate() {
    if(! this.content.showDate) {
      return ''
    }
    return `<div class="wf-blog-posts-date ${this.classes.dateClasses}">
      <span v-text="post.published_at"></span>
    </div>`
  }

  buildBlogPostsTags() {
    return `<div>
      <span class="wf-blog-posts-tags wf-inline-block ${this.classes.tagsClasses}" v-for="tag in post.tags" :key="tag.id" v-text="tag.name"></span>
    </div>`
  }

  buildBlogPostsReadMore() {
    return `<div class="${this.classes.readMoreContainerClasses}">
      <a :href="\`/blog/\${post.id}\`" class="wf-blog-posts-read-more ${this.classes.readMoreClasses}">${this.content.readMoreText}</a>
    </div>`
  }
}